import React from 'react';
import '../css/dataTables.css';


const renderTableBody = (headers, data, action) => {
    let body;

    body = data.map((location, index) => {

        return (
            <tr key={index}>
                <td className="overflow-visible"
                    style={{ textAlign: 'center', maxWidth: 40 }}>
                    {index + 1}</td>
                <td className="overflow-visible"
                    style={{ textAlign: 'center', maxWidth: 800 }}>
                    {location.BinCode || ""}</td>
                <td style={{ textAlign: "center" }}>
                    <button type="button" className="btn btn-sm"
                        onClick={() => action(location)}
                        style={{ fontWeight: '500', backgroundColor: "transparent", color: "#EABF28" }}>
                        <i className="fas fa-check"></i>
                    </button>
                </td>
            </tr>
        )
    })

    return body;
};

const renderTable = (headers, data, action) => {
    let header = "";
    let body = "";

    if (headers.length !== 0) {
        header = <tr>
            <td className="sticky-header table-header-yellow " style={{ textAlign: 'center', maxWidth: 40 }}>{headers[0].title}</td>
            <td className="sticky-header table-header-yellow " style={{ textAlign: 'center', maxWidth: 800 }}>{headers[1].title}</td>
            <td className="sticky-header table-header-yellow "></td>
        </tr>;
    }

    body = renderTableBody(headers, data, action);

    let table = "";

    table =
        <div className="table-wrapper-scroll-y my-custom-scrollbar">
            <table id="dataTableCreate" className="display" style={{ width: '100%', overflow: 'auto' }}>
                <thead className="table-header ">
                    {header}
                </thead>
                <tbody>
                    {body}
                </tbody>
            </table>
        </div>;

    return table;

};

export const renderTableLocationsAssignment = (headers, data, action) => {

    return renderTable(headers, data, action);

}
